module.exports = __webpack_public_path__ + "static/media/bath_bs.17e08aa7.jpg";